module.exports = __webpack_public_path__ + "static/media/SPEI.6dce8889.png";